import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, useModalControl } from '@frontend/design-system';
import { useCompactTableContext, useCompactTableFilterContext } from '../../../context/compact-table-context';

type CompactTableFilterProps = {
  trackingId?: string;
  className?: string;
};

export const CompactTableFilter = ({ trackingId, className }: CompactTableFilterProps) => {
  const { modalProps, triggerProps } = useModalControl();
  const { isLoading } = useCompactTableContext();
  const { showEnabledFiltersBadge, setShowEnabledFiltersBadge, manualFiltersRender } = useCompactTableFilterContext();

  if (!manualFiltersRender) return null;
  return (
    <>
      <div
        className={className}
        css={css`
          position: relative;
        `}
      >
        <Button
          disabled={isLoading}
          css={notificationStyle(!!manualFiltersRender && showEnabledFiltersBadge)}
          label={'Filter'}
          color='light'
          variant='secondary'
          size='medium'
          className='compact-table-filter-button'
          data-test-id={trackingId}
          trackingId={trackingId}
          {...triggerProps}
          iconName='filter-alt'
        />
      </div>
      {manualFiltersRender(modalProps, setShowEnabledFiltersBadge)}
    </>
  );
};

const notificationStyle = (showNotification: boolean) =>
  css`
    ::after {
      position: absolute;
      background: ${theme.colors.primary50};
      border-radius: 16px;
      border: 1.5px solid ${theme.colors.white};
      height: ${theme.spacing(1.5)};
      width: ${theme.spacing(1.5)};
      top: 6px;
      left: ${theme.spacing(3)};
      z-index: ${theme.zIndex.high};
      content: '';
      transition: border-color, opacity ease-in-out 250ms;
      opacity: ${showNotification ? 1 : 0};
    }
    :hover::after,
    :focus::after {
      border-color: ${theme.colors.neutral10};
    }
  `;
